import { Radio, SelectionStatus } from '@symphony-ui/uitoolkit-components';
import * as React from 'react';
const RangeValueSwitch = ({ name, rangeValue, setRangeValue, style = { display: 'flex' } }) => {
    const onChangeRangeValue = React.useCallback((event) => {
        const target = event.target;
        const fullname = target.name;
        const newValue = fullname.replace(name + "-", "");
        setRangeValue(newValue);
    }, [setRangeValue]);
    return (React.createElement("div", { style: style },
        React.createElement(Radio, { label: "Value", name: name + '-value', onChange: onChangeRangeValue, status: rangeValue === 'value' ? SelectionStatus.CHECKED : SelectionStatus.UNCHECKED, value: '' }),
        React.createElement(Radio, { label: "Range", name: name + '-range', onChange: onChangeRangeValue, status: rangeValue === 'range' ? SelectionStatus.CHECKED : SelectionStatus.UNCHECKED, value: '' })));
};
export default RangeValueSwitch;
